// extracted by mini-css-extract-plugin
module.exports = {"Container":"Title_Container__yarMY","Title":"Title_Title__28_7p"};